import { defineStore } from 'pinia';
import { axios } from '../axios';
import { useUiStore } from './ui';

export const useCursosStore = defineStore('cursos', {
  state: () => ({
    // ----- listado de cursos -----
    cursos: [],
    loadingCursos: false,
    errorCursos: null,

    // ----- curso “activo” + módulos -----
    curso: null,
    loadingCurso: false,

    moduls: null,
    encuestascurso: [],

    loadingModuls: false,
    loadingEncuestas: false,

    // ----- datos de alumnos/notas -----
    tablaCuestionarios: [],
    tablaTeoria: [],
    tablaPractica: [],
    tablaNotas: [],
    tablaEncuestas: [],
    timeSlotsCurso: [],

    // ---- respuestas de cuestionarios -----
    tablaRespuestas: [],
    loadingRespuestas: false,

    // ----- cuestionario individual -----
    cuestionario: null,
    loadingCuestionario: false,
  }),

  getters: {
    isCursosLoading: state => state.loadingCursos,
    isCursoLoading: state => state.loadingCurso,
    isModulsLoading: state => state.loadingModuls,
    isCuestionarioLoading: state => state.loadingCuestionario,
  },

  actions: {
    // ---------- listado de cursos ----------
    async fetchCursos() {
      this.loadingCursos = true;
      try {
        const { data } = await axios.get('apren/');
        this.cursos = data;
        this.errorCursos = null;
      } catch (err) {
        console.error('Error al obtener los cursos:', err);
        this.errorCursos = 'Error al obtener los cursos';
      } finally {
        this.loadingCursos = false;
      }
    },

    // ---------- curso concreto ----------
    async fetchCurso(cursoId) {
      this.loadingCurso = true;
      const ui = useUiStore();

      try {
        const { data } = await axios.get(`curso/${cursoId}/`);
        this.curso = data;
      } catch (err) {
        console.error(err);
        ui.triggerSnackbar({ message: 'Error cargando el curso', color: 'error' });
      } finally {
        this.loadingCurso = false;
      }
    },

    // ---------- módulos ----------
    async fetchModuls(cursoId) {
      const ui = useUiStore();
      const vista = ui.selectedOptionVista || 'alumno';
      // Arrancamos el loading de módulos
      this.loadingModuls = true;
      // Reseteamos encuestascurso y su loading
      this.encuestascurso = [];
      this.loadingEncuestas = false;

      try {
        // 1) Traemos los módulos
        const { data: modulosData } = await axios.get(`curso_i/${cursoId}/${vista}/`);
        this.moduls = modulosData;

        // 2) Si la vista es 'alumno', llamamos al endpoint de encuestas
        if (vista === 'alumno') {
          this.loadingEncuestas = true;
          try {
            const { data: encuestasData } = await axios.get(`curso_encuestas/${cursoId}/`);
            this.encuestascurso = encuestasData; // <-- aquí guardamos en encuestascurso
          } catch (errEncuestas) {
            console.error('Error cargando encuestas:', errEncuestas);
          } finally {
            this.loadingEncuestas = false;
          }
        }

      } catch (err) {
        console.error(err);
        if (vista !== 'alumno') {
          ui.setSelectedOptionVista('alumno');
        } else {
          console.error('Error cargando módulos:', err);
        }
      } finally {
        this.loadingModuls = false;
      }
    },

    // ---------- alumnos + notas ----------
    async fetchAlumnosTotal(cursoId) {
      try {
        const { data } = await axios.get(`/curso/${cursoId}/alumnos_total/`);

        this.tablaCuestionarios = data.tabla_cuestionarios;
        this.tablaTeoria = data.tabla_teoria;
        this.tablaPractica = data.tabla_practica;
        this.tablaNotas = data.tabla_notas;
        this.tablaEncuestas = data.tabla_encuestas;
        this.timeSlotsCurso = data.timeSlotsCurso;
      } catch (err) {
        console.error('Error fetching alumnos_total:', err);
      }
    },
    
    // ---------- respuestas de cuestionarios ----------
    async fetchRespuestasCurso(cursoId) {
      this.loadingRespuestas = true;

      try {
        const { data } = await axios.get(`/curso/${cursoId}/respuestas/`);
        this.tablaRespuestas = data;
      } catch (err) {
        console.error('Error fetching respuestas del curso:', err);
        this.tablaRespuestas = [];
      } finally {
        this.loadingRespuestas = false;
      }
    },

    // ---------- cuestionario ----------
    async fetchCuestionario(cuestionarioId) {
      this.loadingCuestionario = true;
      try {
        const { data } = await axios.get(`cuestionario/${cuestionarioId}/`);
        this.cuestionario = data;
      } catch (err) {
        console.error('Error fetching cuestionario:', err);
      } finally {
        this.loadingCuestionario = false;
      }
    },
  },
});
